<template>
  <VueBaseDialog ref="VueBaseDialog" :dialogConfig="dialogConfig">
    <iframe :src="dialogConfig.path" frameborder="0" style="width: 70vw; height: 80vh"></iframe>
  </VueBaseDialog>
</template>
<script>
import VueBaseDialog from '@/components/VueBaseDialog'
export default {
  name: 'PreviewPdf',
  components: {
    VueBaseDialog,
  },
  props: ['dialogConfig'],
  data () {
    return {

    }
  },
  mounted () {
  },
  methods: {
  }
}
</script>

<style scoped lang="less">
.eolDialog-outer-box {
  padding: 20px 30px;
  width: 100%;
  box-sizing: border-box;
}
</style>